import React from 'react'
import styles from './style/step-header-mod.module.less'
import {
  IconArrowLeft,
  IconArrowRight,
  IconCheck,
} from '@arco-iconbox/react-aidb-v2'

function StepHeaderMod(props) {
  const step = [
    {
      title: '添加信息',
    },
    {
      title: '生成标题',
    },
    {
      title: '生成简介',
    },
    {
      title: '生成大纲',
    },
    {
      title: '生成文章',
    },
  ]
  const curStep = props.curStep

  function handleStepClick(index) {
    if (index <= props.curStep) {
      props.jumpTo(index, {})
    }
  }
  return (
    <div className={styles.header}>
      <div className={styles.header_left}>
        <div
          className={styles.backIcon}
          onClick={() => (window.location.href = '/home')}>
          <IconArrowLeft />
        </div>
        <span>{props.title}</span>
      </div>
      {!props.hideStep && (
        <div className={styles.header_step}>
          {step.map((item, index) => {
            return (
              <div
                key={index}
                onClick={() => handleStepClick(index)}
                className={`${styles.step_item} ${
                  curStep >= index ? styles.active : ''
                }`}>
                {index === 0 ? null : (
                  <div className={styles.step_item_icon}>
                    <IconArrowRight />
                  </div>
                )}
                <div className={styles.step_item_index}>
                  {curStep > index ? <IconCheck /> : index + 1}
                </div>
                <div className={styles.step_item_title}>{item.title}</div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default StepHeaderMod
